__webpack_require__.p = "/reports-dashboard-templates-feature-discrimination/referrals-hub/";